module.exports = __webpack_public_path__ + "static/media/tyre-truck-top-view-22w.b71ad5e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/tyre-truck-top-view-22w.png
// module id = 3312
// module chunks = 0